import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FeatureState, featureKey } from './meta-data.reducer';

const selectFeature = createFeatureSelector<FeatureState>(featureKey);

const selectVersions$ = createSelector(selectFeature, (state) => state.versions);

export const fromMetaData = { selectVersions$ };
